import React from "react";
import { AlertTriangle, Check, ShieldCheck, Phone } from "lucide-react";
import { SITE } from "../lib/site";

const PROTECTIONS = [
  "Spot scams",
  "Avoid fraud",
  "Stay safe online",
  "Protect your money and information",
  "Peace of mind",
];

export default function ScamEducation() {
  return (
    <section id="scam-education" data-testid="scam-education-section" className="py-14 md:py-20 bg-white">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="bg-[#FEF3F2] border-2 border-[#CC0000]/25 rounded-3xl overflow-hidden shadow-xl shadow-[#CC0000]/10">
          <div className="p-6 md:p-10 grid md:grid-cols-3 gap-6 md:gap-10 items-center">
            {/* Left: title + subtitle */}
            <div className="md:col-span-1 text-center md:text-left">
              <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-full bg-[#CC0000] shadow-lg mb-4">
                <AlertTriangle className="w-9 h-9 md:w-11 md:h-11 text-white" strokeWidth={2.5} />
              </div>
              <h2 className="font-[Work_Sans] font-black text-[#CC0000] text-3xl md:text-4xl lg:text-5xl leading-none tracking-tight uppercase">
                Don’t fall <br />for scams!
              </h2>
              <p className="mt-4 text-base md:text-lg text-[#5A1717] font-semibold">
                We help protect you <br className="hidden md:block" />
                and your family.
              </p>
            </div>

            {/* Middle: checklist */}
            <div className="md:col-span-1">
              <ul className="space-y-3">
                {PROTECTIONS.map((p, i) => (
                  <li
                    key={p}
                    data-testid={`scam-protection-${i}`}
                    className="flex items-start gap-3 text-base md:text-lg text-[#0F2E52] font-semibold"
                  >
                    <span className="mt-0.5 inline-flex items-center justify-center w-6 h-6 rounded-full bg-[#6BAF3C] shrink-0">
                      <Check className="w-4 h-4 text-white" strokeWidth={3} />
                    </span>
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right: green safety card */}
            <div className="md:col-span-1">
              <div className="bg-[#6BAF3C] text-white rounded-2xl p-5 md:p-6 shadow-lg h-full flex flex-col">
                <div className="w-12 h-12 rounded-full bg-white/20 grid place-items-center mb-3">
                  <ShieldCheck className="w-7 h-7" strokeWidth={2.5} />
                </div>
                <p className="text-base md:text-lg font-semibold leading-snug">
                  I’ll help keep you safe from scammers, suspicious emails, fake
                  calls and dodgy websites.
                </p>
                <a
                  href={`tel:${SITE.phoneTel}`}
                  data-testid="scam-education-call"
                  className="mt-5 inline-flex items-center justify-center gap-2 bg-white text-[#0F2E52] hover:bg-[#F0F7E8] rounded-xl px-4 py-3 font-[Work_Sans] font-bold text-base shadow-sm"
                >
                  <Phone className="w-5 h-5 text-[#0F2E52]" strokeWidth={2.5} />
                  {SITE.phone}
                </a>
              </div>
            </div>
          </div>

          {/* Bottom strip */}
          <div className="bg-[#CC0000] px-6 py-3 text-center text-white font-[Work_Sans] font-bold text-sm md:text-base uppercase tracking-wider">
            Free call — check with us first. Better safe than scammed.
          </div>
        </div>
      </div>
    </section>
  );
}
